<template>
  <div class="container" v-if="!isLoading">
    <div class="row">
      <div class="col-12">
        <TopNav class="mt-4" />
        <img class="mt-3" :srcset="`${logo} 3x`" />
        <p class="mt-4 mb-3">
          {{ $t('SETTINGS.TEXT.CONNECT_YOUR_CALENDLY_ACCOUNT') }}
        </p>
        <div class="mb-4 d-flex align-items-center">
          <font-awesome-icon
            class="text-primary mr-2"
            :icon="['far', 'info-circle']"
          />
          <a
            href="https://developer.calendly.com/docs/getting-your-authentication-token"
            target="_blank"
          >
            {{ $t('SETTINGS.LINK.NEED_HELP_FINDING_YOUR_CALENDLY_API_KEY') }}
          </a>
        </div>
      </div>
      <div class="col-12">
        <HMTextInput
          :label="$t('SETTINGS.LABEL.CALENDLY_API_KEY')"
          v-model="calendlyApiKey"
          :disabled="!calendlyApiKey"
        />
      </div>
      <hr class="mx-3 w-100" />
      <div class="col-12 form-group">
        <HMButton color="primary" @click="update" :loading="inProgress">
          {{ $t('SETTINGS.BUTTON.UPDATE') }}
        </HMButton>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import TopNav from '@/web/components/navigation/TopNav.vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  name: 'CalendlyIntegration',
  components: {
    TopNav,
  },
  data() {
    return {
      logo: '/assets/images/integrations/calendly@3x.png',
      isLoading: true,
      inProgress: false,
      calendlyApiKey: null,
    };
  },
  methods: {
    async update() {
      this.inProgress = true;
      try {
        await this.$store.dispatch(
          'setting/updateCalendly',
          this.calendlyApiKey
        );
        if (this.calendlyApiKey) {
          this.$notify({
            group: 'app',
            type: 'success',
            title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
            text: this.$t(
              'SETTINGS.NOTIFICATIONS.CALENDLY_API_KEY_SUCCESSFULLY_UPDATED'
            ),
          });
        } else {
          this.$notify({
            group: 'app',
            type: 'success',
            title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
            text: this.$t(
              'SETTINGS.NOTIFICATIONS.CALENDLY_SUCCESSFULLY_DISCONNECTED'
            ),
          });
        }
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
      }
      this.inProgress = false;
    },
    remove() {
      this.calendlyApiKey = null;
      this.updateCalendly();
    },
  },
  async mounted() {
    this.calendlyApiKey = await this.$store.dispatch('setting/getCalendly');
    this.isLoading = false;
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
